import { render, staticRenderFns } from "./HomeAddress.vue?vue&type=template&id=42b5cbb8&scoped=true&"
import script from "./HomeAddress.vue?vue&type=script&lang=js&"
export * from "./HomeAddress.vue?vue&type=script&lang=js&"
import style0 from "./HomeAddress.vue?vue&type=style&index=0&id=42b5cbb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5cbb8",
  null
  
)

export default component.exports